import { ClientConfig } from 'next-sanity';

export const config: ClientConfig = {
  /**
   * Find your project ID and dataset in `sanity.json` in your studio project.
   * These are considered “public”, but you can use environment variables
   * if you want differ between local dev and production.
   *
   * https://nextjs.org/docs/basic-features/environment-variables
   **/
  dataset: process.env.SANITY_DATASET ?? 'production',
  projectId: 'tsbk0zvv',
  apiVersion: '2021-10-21',
};
